var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"content",attrs:{"viewBox":"0 0 900 30"}},[_c('text',{attrs:{"x":"0","y":"0","alignment-baseline":"text-before-edge"}},[_vm._v("Venter ved holdeplass")])])}
var staticRenderFns = []

export { render, staticRenderFns }